export const toggleMenu = () => ({
  type: 'TOGGLE_MENU',
});

export const hideTrialIndicator = () => {
  return {
    type: 'HIDE_TRIAL_INDICATOR',
  };
};
